<template>
  <a-layout class="login" v-if="!logged">
    <a-layout-content class="login__content">
      <a-card title="Login" style="width: 300px;">
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item>
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [
                    {
                      type: 'email',
                      message: 'The input is not valid E-mail!',
                    },
                    {
                      required: true,
                      message: 'Please input your E-mail!',
                    },
                  ],
                },
              ]"
              type="email"
              placeholder="E-mail"
            >
              <a-icon slot="prefix" type="user" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: 'Please input your Password!' },
                  ],
                },
              ]"
              type="password"
              placeholder="Password"
            >
              <a-icon slot="prefix" type="lock" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'otp_attempt',
                {
                  rules: [{ required: false }],
                },
              ]"
              placeholder="2FA Code"
            >
              <a-icon slot="prefix" type="lock" />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              class="login-form-button"
              block
            >
              Log in
            </a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-layout-content>
    <div class="login__loading" v-if="loading">
      <spinner />
    </div>
  </a-layout>
</template>

<script>
import Spinner from "@/components/spinner/Spinner.vue";

export default {
  components: { Spinner },
  data() {
    return {
      loading: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  computed: {
    logged() {
      return this.$store.getters.logged;
    },
  },
  watch: {
    logged() {
      if (this.logged) this.$router.push("/home");
    },
  },
  mounted() {
    if (this.logged) this.$router.push("/home");
  },
  methods: {
    handleSubmit(e) {
      this.loading = true;
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err)
          this.$store.dispatch("login", {
            email: values.email,
            password: values.password,
            otp_attempt: values.otp_attempt,
            callback: () => this.$router.go(),
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.login {
  height: 100%;

  .login__content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .login__loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.8);
  }
}
</style>
